module.exports = __webpack_public_path__ + "static/61-72733a7ae75755cafc536af3bd6aae6a.png";